var map = {
	"./Choice": 7360,
	"./Choice.js": 7360,
	"./Configurator": 163,
	"./Configurator.js": 163,
	"./CutOutsConfigurator": 9414,
	"./CutOutsConfigurator.js": 9414,
	"./Dashboard/Colors/Colors": 6,
	"./Dashboard/Colors/Colors.js": 6,
	"./Dashboard/Colors/EditColor": 5367,
	"./Dashboard/Colors/EditColor.js": 5367,
	"./Dashboard/Colors/NewColor": 4263,
	"./Dashboard/Colors/NewColor.js": 4263,
	"./Dashboard/DashboardMenu": 4888,
	"./Dashboard/DashboardMenu.js": 4888,
	"./Dashboard/Orders/Order": 3525,
	"./Dashboard/Orders/Order.js": 3525,
	"./Dashboard/Orders/Orders": 2467,
	"./Dashboard/Orders/Orders.js": 2467,
	"./Dashboard/Users/EditUser": 7449,
	"./Dashboard/Users/EditUser.js": 7449,
	"./Dashboard/Users/NewUser": 2001,
	"./Dashboard/Users/NewUser.js": 2001,
	"./Dashboard/Users/Users": 5272,
	"./Dashboard/Users/Users.js": 5272,
	"./Finishing": 6845,
	"./Finishing.js": 6845,
	"./FinishingAll": 4604,
	"./FinishingAll.js": 4604,
	"./FinishingSide": 3506,
	"./FinishingSide.js": 3506,
	"./Input": 3004,
	"./Input.js": 3004,
	"./Shopping": 8702,
	"./Shopping.js": 8702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4622;